import React, { useEffect, useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../lib/store';
interface NowFloatingProductAdProps {
  product: {
    id: number;
    name: string;
    brand?: string;
    price: number;
    image: string;
  };
}
const dismissalKey = 'now-floating-ad-dismissed';
export function NowFloatingProductAd({
  product
}: NowFloatingProductAdProps) {
  const navigate = useNavigate();
  const addToCart = useStore(state => state.addToCart);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem(dismissalKey) !== 'true') setIsVisible(true);
  }, []);
  const dismiss = () => {
    sessionStorage.setItem(dismissalKey, 'true');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <aside className="fixed bottom-[82px] right-3 z-30 w-[182px] rounded-xl border border-brand-border bg-white p-2 shadow-[0_10px_28px_rgba(52,52,52,0.16)] md:bottom-6 md:right-6" aria-label="Featured NOW offer" data-id="element-4413" data-mp="2mfdrv8eq2oao">
      <button type="button" onClick={dismiss} className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border border-brand-border bg-white text-brand-muted shadow-sm transition-colors duration-150 hover:text-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Dismiss featured offer" data-id="element-4414" data-mp="297kf0axm4uym">
        <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-4415" data-mp="2s43pb3k5kowr" />
      </button>
      <button type="button" onClick={() => navigate(`/product/${product.id}?from=now`)} className="flex w-full items-center gap-2 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-4416" data-mp="2o3tar2iaoq6a">
        <img src={product.image} alt="" className="h-14 w-14 shrink-0 rounded-lg border border-brand-border object-cover" data-id="element-4417" data-mp="2e65bq0dnowib" />
        <span className="min-w-0" data-id="element-4418" data-mp="17q36nvr6e1wn">
          <span className="block text-[10px] font-bold uppercase tracking-wide text-brand" data-id="element-4419" data-mp="17mxfmayzkpya">NOW PICK</span>
          <span className="mt-0.5 block line-clamp-2 text-xs font-bold leading-4 text-brand-ink" data-id="element-4420" data-mp="147cnxt8tt387">{product.name}</span>
          <span className="mt-1 block text-sm font-bold text-brand" data-id="element-4421" data-mp="196z2c60e4pil">SAR {product.price.toFixed(2)}</span>
        </span>
      </button>
      <button type="button" onClick={() => {
      addToCart({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        brand: product.brand
      });
      dismiss();
    }} className="mt-2 flex h-8 w-full items-center justify-center gap-1 rounded-md bg-brand text-xs font-bold text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-4422" data-mp="v5wdjli0h13z">
        <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-4423" data-mp="ghrsiavhkdi1" /> Add now
      </button>
    </aside>;
}